/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Featureprivacytitle2Inputs */

const he_extension_featureprivacytitle2 = /** @type {(inputs: Extension_Featureprivacytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פרטיות מלאה`)
};

const en_extension_featureprivacytitle2 = /** @type {(inputs: Extension_Featureprivacytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full Privacy`)
};

/**
* | output |
* | --- |
* | "Full Privacy" |
*
* @param {Extension_Featureprivacytitle2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_featureprivacytitle2 = /** @type {((inputs?: Extension_Featureprivacytitle2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Featureprivacytitle2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_featureprivacytitle2(inputs)
	return en_extension_featureprivacytitle2(inputs)
});
export { extension_featureprivacytitle2 as "extension_featurePrivacyTitle" }